module.exports = __webpack_public_path__ + "static/media/TaskAssignment.bf899ad.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/TaskAssignment.mp4
// module id = OXpg
// module chunks = 1